import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "../axios";
import "./AdDetails.css";
import { useNavigate } from "react-router-dom";
import { startConversation } from "../api/chatApi";
import { toggleFavorite } from "../api/favoritesApi";
import BackLink from "./BackLink";
import AdUnavailable from "./AdUnavailable";
import { API_BASE_URL } from "../config";

const normalize = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${API_BASE_URL}${url}`;
};

const formatAdDateAthensGR = (isoString) => {
  if (!isoString) return "";

  const d = new Date(isoString);

  const datePart = d.toLocaleDateString("el-GR", {
    day: "numeric",
    month: "long",
    timeZone: "Europe/Athens",
  });

  const timePart = d.toLocaleTimeString("el-GR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/Athens",
  });

  // "5 Ιανουαρίου στις 14:52"
  return `${datePart} στις ${timePart}`;
};

const getProfileId = (profile) => {
  if (!profile) return null;
  if (typeof profile === "object") return profile.id;
  return profile;
};


const AdDetails = ({ user }) => {
  const { id } = useParams();
  const navigate = useNavigate();  
  const trackResponse = async (channel) => {
    try {
      await axios.post(`/api/ads/${id}/track/`, {
        event: "response",
        channel, // "phone" | "copy" | "message"
      });
    } catch (e) {
      console.log("track response error", e);
    }
  };
  const handleWriteToSeller = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.dispatchEvent(
        new CustomEvent("open-login-modal", {
          detail: { message: "Παρακαλώ συνδεθείτε για να στείλετε ένα μήνυμα." },
        })
      );
      return;
    }

    await trackResponse("message");

    try {
      
      const sellerProfileId = getProfileId(ad.profile);

      if (!sellerProfileId) {
        alert("Δεν βρέθηκε ο πωλητής της αγγελίας.");
        return;
      }

      const conv = await startConversation(ad.id, sellerProfileId, token);

      navigate(
        `/chat?conversation=${conv.id}&backTo=${encodeURIComponent(`/ads/${ad.id}`)}`
      );
    } catch (e) {
      console.error(e);
      alert("Δεν ήταν δυνατή η έναρξη συνομιλίας.");
    }
  };
  const handleToggleFavorite = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      window.dispatchEvent(
        new CustomEvent("open-login-modal", {
          detail: { message: "Παρακαλώ συνδεθείτε για να προσθέσετε στα αγαπημένα." },
        })
      );
      return;
    }

    if (!ad?.id) return;

    // 1) мгновенный UI
    setIsFavorite((prev) => !prev);

    try {
      // 2) переключаем на сервере
      const res = await toggleFavorite(ad.id); // { is_favorite: true/false }

      // 3) синхронизируем UI с сервером
      if (typeof res?.is_favorite === "boolean") {
        setIsFavorite(res.is_favorite);
      }

    } catch (e) {
      console.error("Σφάλμα αλλαγής αγαπημένου:", e);

      // откат
      setIsFavorite((prev) => !prev);
      alert("Δεν ήταν δυνατή η ενημέρωση των αγαπημένων.");
    }
  };
  const [ad, setAd] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [showPhone, setShowPhone] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);  
  const [isFavorite, setIsFavorite] = useState(false);
    // открыта ли полноэкранная картинка
  const [isLightboxOpen, setLightboxOpen] = useState(false);

  const openLightbox = () => setLightboxOpen(true);
  const closeLightbox = () => setLightboxOpen(false);
  const [seller, setSeller] = useState(null);
  const [sellerActiveAdsCount, setSellerActiveAdsCount] = useState(0);
  const [isFollowingSeller, setIsFollowingSeller] = useState(false);  
  // ===== Owner stats (μόνο για τον ιδιοκτήτη αγγελίας) =====
  const [statsPeriod, setStatsPeriod] = useState("7"); // default: 7 days
  const [statsOpen, setStatsOpen] = useState(false);
  const [ownerStats, setOwnerStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const viewTrackedRef = useRef(false);
  // определяем, моё ли это объявление (безопасно, даже если ad = null)
  const sellerProfileId = getProfileId(ad?.profile);

  const isMyAd =
    !!user?.profile?.id &&
    !!sellerProfileId &&
    Number(user.profile.id) === Number(sellerProfileId);
  

  const handleToggleFollowSeller = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.dispatchEvent(
        new CustomEvent("open-login-modal", {
          detail: { message: "Παρακαλώ συνδεθείτε για να ακολουθήσετε τον πωλητή." },
        })
      );
      return;
    }
    const sellerProfileId = getProfileId(ad?.profile);
    if (!sellerProfileId) return;

    setIsFollowingSeller((v) => !v);

    try {
      await axios.post(`/api/profiles/${sellerProfileId}/follow/`);
    } catch (e) {
      console.error("Σφάλμα follow:", e);
      setIsFollowingSeller((v) => !v);
      alert("Σφάλμα. Προσπαθήστε ξανά.");
    }
  };


useEffect(() => {
  // сброс при смене id
  setAd(null);
  setNotFound(false);
  setLoadError("");
  viewTrackedRef.current = false;

  axios
    .get(`/api/ads/${id}/`)
    .then(async (response) => {
      setAd(response.data);
      setIsFavorite(!!response.data.is_favorite);

      // ✅ грузим публичный профиль продавца
      try {
        const profileId = getProfileId(response.data.profile);
        if (profileId) {
          const pRes = await axios.get(`/api/profiles/${profileId}/public/`);
          setSeller(pRes.data?.profile || null);
          setSellerActiveAdsCount(
            Array.isArray(pRes.data?.active_ads) ? pRes.data.active_ads.length : 0
          );

          const token = localStorage.getItem("token");
          if (token) {
            const sRes = await axios.get(`/api/profiles/${profileId}/is-following/`);
            setIsFollowingSeller(!!sRes.data?.is_following);
          }
        }
      } catch (e) {
        console.error("Σφάλμα φόρτωσης πωλητή:", e);
      }
    })
    .catch((e) => {
      const status = e?.response?.status;

      if (status === 404) {
        // ✅ объявление реально не существует
        setNotFound(true);
        setAd(null);
        return;
      }

      // ✅ любая другая ошибка
      console.error("Σφάλμα φόρτωσης αγγελίας:", e);
      setLoadError("❌ Σφάλμα φόρτωσης αγγελίας. Προσπαθήστε ξανά.");
      setAd(null);
    });
}, [id]);

  useEffect(() => {
    const loadOwnerStats = async () => {
      if (!ad?.id) return;
      if (!isMyAd) return;

      try {
        setStatsLoading(true);
        const res = await axios.get(`/api/ads/${ad.id}/stats/`, {
          params: { period: statsPeriod },
        });
        setOwnerStats(res.data?.totals || null);
      } catch (e) {
        console.error("Σφάλμα φόρτωσης στατιστικών:", e);
        setOwnerStats(null);
      } finally {
        setStatsLoading(false);
      }
    };

    loadOwnerStats();
  }, [ad?.id, isMyAd, statsPeriod]);

  useEffect(() => {
    if (!ad?.id) return;
    if (viewTrackedRef.current) return;

    viewTrackedRef.current = true;

    axios
      .post(`/api/ads/${ad.id}/track/`, { event: "view" })
      .catch((e) => console.log("track view error", e));
  }, [ad?.id]);



if (notFound) {
  return <AdUnavailable adId={id} />;
}

if (loadError) {
  return (
    <AdUnavailable
      adId={id}
      title="Κάτι πήγε στραβά"
      text={loadError}
    />
  );
}

if (!ad) return <div className="loading">🔄 Φόρτωση αγγελίας...</div>;

  return (
    <>
      {/* Стрелка "назад" — чуть ниже шапки только на этой странице */}
      <div className="ad-details-backlink">
        <BackLink label="Πίσω" />
      </div>

      {/* Основной контент объявления */}
      <div className="ad-details-container">
        <div className="ad-image-section">
          {/* БОЛЬШОЕ ПРЕВЬЮ */}
          <div className="ad-preview">
            <img
              src={normalize(ad.images?.[currentIndex]?.image) || "/no-image.png"}
              alt={ad.title}
              className="ad-preview__img"
              onError={(e) => (e.currentTarget.src = "/no-image.png")}
              onClick={openLightbox}
              style={{ cursor: "zoom-in" }}
            />
          </div>

          {/* ЛЕНТА МИНИАТЮР */}
          {Array.isArray(ad.images) && ad.images.length > 1 && (
            <div className="ad-thumbs">
              {ad.images.map((img, idx) => (
                <button
                  key={img.id || img.image}
                  type="button"
                  className={`ad-thumb ${idx === currentIndex ? "is-active" : ""}`}
                  onClick={() => setCurrentIndex(idx)}
                >
                  <img
                    src={normalize(img.image)}
                    alt=""
                    onError={(e) => (e.currentTarget.src = "/no-image.png")}
                  />
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="ad-info-section">
          <div className="ad-header-row">
            <h1 className="ad-title">{ad.title}</h1>            

            {/* ❤️ Кнопка избранного — как на карточке */}
            <button
              type="button"
              className="ad-favorite-btn"
              onClick={handleToggleFavorite}
              title={isFavorite ? "Αφαίρεση από τα αγαπημένα" : "Προσθήκη στα αγαπημένα"}
            >
              <svg
                className={isFavorite ? "heart-icon filled" : "heart-icon"}
                viewBox="-2 -2 28 28"
                aria-hidden="true"
              >
                <path
                  d="M12 22 C12 22 3 14.2 3 8.5 C3 5 5.6 2.5 9 2.5 C11 2.5 12.7 3.6 13.7 5.2 C14.7 3.6 16.4 2.5 18.4 2.5 C21.8 2.5 24 5 24 8.5 C24 14.2 15 22 15 22 C14 23 13 23 12 22 Z"
                />
              </svg>
            </button>
          </div>

          <div className="ad-meta">
            № {ad.id}, {formatAdDateAthensGR(ad.created_at)}
          </div>
          {/* ===== Owner stats block (μόνο αν είναι δική μου αγγελία) ===== */}
          {isMyAd && (
            <div className="owner-stats">
              <div className="owner-stats-head">
                <div className="owner-stats-title">Στατιστικά αγγελίας</div>

                <div className="owner-stats-period">
                  <button
                    type="button"
                    className="owner-stats-period-btn"
                    onClick={() => setStatsOpen((v) => !v)}
                  >
                    {statsPeriod === "7"
                      ? "Τελευταίες 7 ημέρες"
                      : statsPeriod === "30"
                      ? "Τελευταίες 30 ημέρες"
                      : "Όλο το χρονικό διάστημα"}
                    <span style={{ marginLeft: 8 }}>▾</span>
                  </button>

                  {statsOpen && (
                    <div className="owner-stats-period-menu">
                      <button
                        type="button"
                        onClick={() => {
                          setStatsPeriod("7");
                          setStatsOpen(false);
                        }}
                      >
                        Τελευταίες 7 ημέρες
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setStatsPeriod("30");
                          setStatsOpen(false);
                        }}
                      >
                        Τελευταίες 30 ημέρες
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setStatsPeriod("all");
                          setStatsOpen(false);
                        }}
                      >
                        Όλο το χρονικό διάστημα
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {statsLoading ? (
                <div className="owner-stats-loading">Φόρτωση...</div>
              ) : ownerStats ? (
                <div className="owner-stats-grid">
                  <div className="owner-stat">
                    <div className="owner-stat-num">{ownerStats.impressions ?? 0}</div>
                    <div className="owner-stat-label">Προβολές στη λίστα</div>
                  </div>

                  <div className="owner-stat">
                    <div className="owner-stat-num">{ownerStats.views ?? 0}</div>
                    <div className="owner-stat-label">Προβολές αγγελίας</div>
                  </div>

                  <div className="owner-stat">
                    <div className="owner-stat-num">{ownerStats.favorites ?? 0}</div>
                    <div className="owner-stat-label">Αγαπημένα</div>
                  </div>

                  <div className="owner-stat">
                    <div className="owner-stat-num">{ownerStats.responses ?? 0}</div>
                    <div className="owner-stat-label">Ανταποκρίσεις</div>
                  </div>
                </div>
              ) : (
                <div className="owner-stats-loading" style={{ opacity: 0.7 }}>
                  Δεν υπάρχουν δεδομένα.
                </div>
              )}
            </div>
          )}
          <p className="ad-price">{ad.price} €</p>
          <p className="ad-location">📍 {ad.location}</p>
          <p className="ad-date">
            📅 {new Date(ad.created_at).toLocaleDateString()}
          </p>

          <div className="ad-description">
            <h3>Περιγραφή</h3>
            <p>{ad.description}</p>
          </div>
          {/* 👤 Προφίλ πωλητή */}
          <div className="seller-box">
            <div
              className="seller-click"
              onClick={() => {
                const sellerProfileId = getProfileId(ad?.profile);
                if (sellerProfileId) navigate(`/seller/${sellerProfileId}`);
              }}
              role="button"
              title="Άνοιγμα προφίλ πωλητή"
            >
              {seller?.avatar ? (
                <img className="seller-mini-avatar" src={normalize(seller.avatar)} alt="seller" />
              ) : (
                <div className="seller-mini-avatar seller-mini-placeholder">
                  {(seller?.name || "Π").charAt(0).toUpperCase()}
                </div>
              )}

              <div className="seller-mini-meta">
                <div className="seller-mini-topline">
                  <span className="seller-mini-title">Προφίλ πωλητή</span>

                  <span className="seller-mini-separator">|</span>

                  <span
                    className="seller-mini-adslink"
                    onClick={(e) => {
                      e.stopPropagation();
                      const sellerProfileId = getProfileId(ad?.profile);
                      if (sellerProfileId) navigate(`/seller/${sellerProfileId}`);
                    }}
                  >
                    {sellerActiveAdsCount} Αγγελίες
                  </span>
                </div>

                <div className="seller-mini-name">
                  {seller?.name || seller?.email || "Πωλητής"}
                </div>
              </div>
             </div> 

            <div className="seller-follow-wrap">
              {!isMyAd && (
                <button
                  type="button"
                  className={isFollowingSeller ? "btn btn-outline" : "btn btn-primary"}
                  onClick={handleToggleFollowSeller}
                >
                  {isFollowingSeller ? "Ακολουθείτε" : "Ακολούθησε"}
                </button>
              )}                            
            </div>
          </div>
          {!isMyAd && (
            showPhone ? (
              <div className="contact-buttons">
                <a
                  className="contact-button contact-button--phone"
                  href={`tel:${ad.contact_phone}`}
                  onClick={() => trackResponse("phone")}
                >
                  📞 {ad.contact_phone}
                </a>

                <button
                  className="contact-button contact-button--copy"
                  onClick={async () => {
                    navigator.clipboard.writeText(ad.contact_phone);
                    alert("📋 Ο αριθμός αντιγράφηκε!");
                    await trackResponse("copy");
                  }}
                >
                  📋 Αντιγραφή
                </button>

                <button
                  className="contact-button contact-button--message"
                  onClick={handleWriteToSeller}
                >
                  💬 Μήνυμα στον πωλητή
                </button>
              </div>
            ) : (
              <div className="contact-buttons">
                <button
                  className="contact-button"
                  onClick={() => setShowPhone(true)}
                >
                  📞 Επικοινωνία με τον πωλητή
                </button>

                <button
                  className="contact-button contact-button--message"
                  onClick={handleWriteToSeller}
                >
                  💬 Μήνυμα στον πωλητή
                </button>
              </div>
            )
          )}
        </div>
      </div>

      {/* Полноэкранный просмотр картинок — ОТДЕЛЬНО от контейнера */}
      {isLightboxOpen && (
        <div className="lb-backdrop" onClick={closeLightbox}>
          <div className="lb-content" onClick={(e) => e.stopPropagation()}>
            {Array.isArray(ad.images) && ad.images.length > 1 && (
              <div className="lb-thumbs">
                {ad.images.map((img, idx) => (
                  <button
                    key={img.id || img.image}
                    type="button"
                    className={`lb-thumb ${idx === currentIndex ? "is-active" : ""}`}
                    onClick={() => setCurrentIndex(idx)}
                    aria-label={`Фото ${idx + 1}`}
                  >
                    <img
                      src={normalize(img.image)}
                      alt=""
                      onError={(e) => (e.currentTarget.src = "/no-image.png")}
                    />
                  </button>
                ))}
              </div>
            )}

            <div className="lb-main">
              <img
                className="lb-image"
                src={normalize(ad.images?.[currentIndex]?.image)}
                alt={ad.title}
                onError={(e) => (e.currentTarget.src = "/no-image.png")}
              />

              {ad.images?.length > 1 && (
                <button
                  className="lb-arrow left"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex((prev) =>
                      prev === 0 ? ad.images.length - 1 : prev - 1
                    );
                  }}
                >
                  ‹
                </button>
              )}

              {ad.images?.length > 1 && (
                <button
                  className="lb-arrow right"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex((prev) =>
                      prev === ad.images.length - 1 ? 0 : prev + 1
                    );
                  }}
                >
                  ›
                </button>
              )}

              <button
                className="lb-close"
                aria-label="Close"
                onClick={(e) => {
                  e.stopPropagation();
                  closeLightbox();
                }}
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdDetails;